import gsap, { SplitText, ScrollTrigger } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";
import { animSplitSlideUp } from "@/animations/split";

export default function (element: HTMLElement, dataset: any) {
  let tls = animSplitSlideUp(element);
}
